export const makeBase64UrlSafe = (base64EncodedString) => {
    return base64EncodedString
        .replace(/=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_");
};
export const concatUInt8Arrays = (array1, array2) => {
    const mergedArray = new Uint8Array(array1.length + array2.length);
    mergedArray.set(array1);
    mergedArray.set(array2, array1.length);
    return mergedArray;
};
export const isValidObject = (obj) => Object.getPrototypeOf(obj) === Object.prototype && Object.keys(obj).length;
export const objectToHex = (obj) => {
    if (!isValidObject(obj)) {
        throw new Error(`Supplied object is not valid ${JSON.stringify(obj)}`);
    }
    return makeBase64UrlSafe(Buffer.from(new TextEncoder().encode(JSON.stringify(obj))).toString("base64"));
};
//# sourceMappingURL=helpers.js.map